import { getOrigin } from "../utils";

export default {
  // Estado del loader
  // Inicialmente mostramos el loader
  // luego de que carga la primera vista
  // lo quitamos
  isLoading: true,
  trackClickElement: null,
  trackOnClickStart: null,
  isExceeded: false,
  adobeTargetExperience: null,
  origen: getOrigin(),
  mock: null,
  // Model del paso 1
  paso1: {
    camp: _BBVA_MOTOR || "",
    cuit: "",
    razonSocial: "",
    nombreYApellido: "",
    nombre: "",
    apellido: "",
    phone: { area: "", numero: "" },
    telefono: ""
  },
  responseConsulta: {
    status: "",
    respuesta: {
      respuesta: "",
      randomKey: "",
      mensaje: "",
      carro: ""
    },
    razonSocialerrorCode: ""
  },
  paso2: {
    camp: _BBVA_MOTOR || "",
    cuit: "",
    razonSocial: "",
    nombreYApellido: "",
    telefono: "",
    email: "",
    facturacionUltimoBalance: "",
    facturacionAnteriorBalance: "",
    resultadoOperativo: "",
    resultadoFinal: "",
    patrimonioNeto: "",
    randomKey: ""
  },
  responseOferta: {
    status: "",
    respuesta: {
      oferta: {
        montoMaximo: "",
        montoLargoPlazo: "",
        estado: "",
        esCliente: false
      },
      randomKey: ""
    },
    errorCode: null
  },
  paso4: {
    phone: { area: "", numero: "" },
    telefono: "",
    email: "",
    numSucursal: "",
    sucursal: null,
    randomKey: ""
  },
  reactivo: {
    paso1: {
      camp: _BBVA_MOTOR || "",
      cuit: "",
      razonSocial: "",
      nombreYApellido: "",
      nombre: "",
      apellido: "",
      phone: { area: "", numero: "" },
      landPhone: { tipo: "movil", numero: "" },
      telefono: "",
      email: "",
      razonSocialRef: "",
      cuitReferidor: "",
      relacion: "",
      mailRef: ""
    },
    oferta: {
      cuit: "",
      razonSocial: "",
      maximosOferta: {
        oferta: 0,
        visaBusiness: 0,
        cuentaCorriente: 0,
        prestamoFinanciero: 0,
        descuentoCheques: 0
      }
    },
    confirmacionSucursal: null
  },
  agroData: {
    datosPersonales: {
      nombre: "",
      apellido: "",
      dniCuit: "",
      telefono: "",
      email: ""
    },
    datosProduccion: {
      tipoProduccion: "",
      provincia: "",
      departamento: "",
      granos: {
        sojaPrimera: false,
        sojaSegunda: false,
        maizPrimera: false,
        maizSegunda: false,
        girasol: false,
        trigoCebada: false
      },
      hectareas: {
        sojaPrimera: "",
        sojaSegunda: "",
        maizPrimera: "",
        maizSegunda: "",
        girasol: "",
        trigoCebada: "",
        porcentaje: ""
      },
      cabezasDeGanado: "",
      arrendamiento: 0,
      stock: {
        deudaCorto: "",
        deudaLargo: "",
        sojaPrimera: "",
        sojaSegunda: "",
        maizPrimera: "",
        maizSegunda: "",
        girasol: "",
        trigoCebada: ""
      }
    }
  },
  cuitAgroValidado: null,
  agroEsCliente: null,
  ofertaAgro: null,
  responseGenerarOTP: null,
  telefonoVerificado: false,
  emailVerificado: false,
  agroError: {
    title: "",
    subtitle: "",
    image: "",
    hasAction: false,
    action: null,
    actionPayload: null,
    returnRoute: null,
    successAction: null,
    tituloMaxIntentos: "",
    subtituloMaxIntentos: "",
    buttonLabel: null
  }
};
